import type { Recommendation } from '../types';

// BACKWARD COMPAT for the proposal shape change ({change,current,why,impact} → {title,description,why}).
// ProposalVersion snapshots are immutable and never migrated, so a task's stored proposals (in a version
// row or the payload mirror) can carry EITHER shape. Coalesce at read time so an old draft renders as
// title/description/why instead of blanks. Fresh proposals always have the new fields; this only ever
// matters when rendering a historical row.
type LegacyRecommendation = Partial<Recommendation> & {
  change?: string;
  current?: string;
  impact?: string;
};

export function normalizeRecommendation(r: LegacyRecommendation): Recommendation {
  return {
    title: r.title ?? r.change ?? '',
    description: r.description ?? r.current ?? r.change ?? '',
    why: r.why ?? '',
  };
}
